import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import IBSUCertificateImage from "../../../../components/Certificate/IBSUCertificate/IBSUOther/IBSUCertificateImage";
import { useDispatch, useSelector } from "react-redux";
import { editCertificate, getCertificateById } from "../../../../redux/features/certificate/certificateService";
import NoResultsFound from "../../../../components/NoResultsFound";
import GridLoader from "react-spinners/GridLoader";
import { showToast } from "../../../../components/ToastMsg";
import Modal from "../../../../components/Modal";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import IBSUOfficialCertificateImage from "../../../../components/Certificate/IBSUCertificate/IBSUOfficial/IBSUOfficialCertificateImage";
import IBSCOfficialCertificateImage from "../../../../components/Certificate/IBSCCertificate/IBSCOfficial/IBSCOfficialCertificateImage";
import CDCCertificateImage from "../../../../components/Certificate/CDCCertificate/CDCOther/CDCCertificateImage";

const PreviewCertificate = () => {
    const { certificate_id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isLoadingCertificateDetails, isCertificateDetailsSuccess, certificate } = useSelector((state) => state.certificate.certificateDetails);

    const [certificateImage, setCertificateImage] = useState(null);
    const [disabledEditBtn, setEditBtnDisable] = useState(false);
    const [isActivateModalOpen, setActivateModalOpen] = useState(false);

    useEffect(() => {
        dispatch(getCertificateById({ certificate_id })).unwrap();
    }, [dispatch, certificate_id]);

    const closeModal = () => setActivateModalOpen(false);

    const handleYes = async () => {
        setActivateModalOpen(false);
        setEditBtnDisable(true);
        try {
            const response = await dispatch(editCertificate({ id: certificate_id, certificate_status: 'Verified' })).unwrap();
            showToast('success', response.message);
            navigate('/controller/certificates');
        }
        catch (error) {
            showToast('error', error.message);
        };
    };

    return (
        <div className={`main-card`}>
            {isLoadingCertificateDetails ? (
                <div className={`loader-style`}>
                    <GridLoader color="#df771c" />
                </div>
            ) : !isCertificateDetailsSuccess ? (
                <NoResultsFound />
            ) : (
                <>
                    {certificate?.certificate_template?.name === 'IBSU Offical Certificate' ?
                        <IBSUOfficialCertificateImage data={certificate} onImageGenerated={setCertificateImage} />
                        : certificate?.certificate_template?.name === 'IBSC Official Certificate' ?
                            <IBSCOfficialCertificateImage data={certificate} onImageGenerated={setCertificateImage} />
                            :
                            <CDCCertificateImage data={certificate} onImageGenerated={setCertificateImage} />
                    }
                    {certificateImage !== null ? (
                        <div>
                            <div className={`form-input-row`}>Certificate Preview
                                {certificate.certificate_status === 'Pending' &&
                                    <button
                                        className={`btn-approve`}
                                        type='button'
                                        disabled={disabledEditBtn}
                                        onClick={() => setActivateModalOpen(true)}
                                    >
                                        Verify Certificate
                                    </button>
                                }
                            </div>
                            <img src={certificateImage} alt="Certificate Preview" style={{ width: "100%", maxWidth: "400px", border: "1px solid #ccc" }} />
                        </div>
                    ) : <div className={`loader-style`}>
                        <GridLoader color="#df771c" />
                    </div>}
                </>
            )}
            {isActivateModalOpen && (
                <Modal
                    title='Verify Certificate'
                    onClose={closeModal}
                    onYes={handleYes}
                    isInput={false}
                    iconName={faCircleCheck}
                    bodyText={`Are you sure you want to verify the Certificate?`}
                    colorType={`var(--green)`}
                />
            )}
        </div>
    );
};
export default PreviewCertificate;
